import { useState } from 'react';

export function useEntityDialog<T>() {
  const [state, setState] = useState<{ open: boolean; data: Partial<T> }>({
    open: false,
    data: {},
  });

  const openDialog = (data: Partial<T>) => setState({ open: true, data });
  const closeDialog = () => setState({ open: false, data: {} });

  return { ...state, openDialog, closeDialog };
}
